var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`rounded-${_vm.rounded} shimmer h-${_vm.h} w-${_vm.w} `})
}
var staticRenderFns = []

export { render, staticRenderFns }